export default {
  props: ['title', 'info', 'fullscreen', 'viewProduct'],
  computed: {
    carouselView() {
      return this.$store.getters.CAROUSEL_VIEW;
    },
    replacedPhotoProduct() {
      return this.$store.getters.REPLACED_PHOTO_DATA;
    },
  },
}
